module.exports = __webpack_public_path__ + "media/Loops 90 Bass.3f51b498.wav";